import { useMutation, useQuery, UseQueryOptions, QueryKey } from "react-query";
import { SUPPLIERS_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";
import { JobType } from ".";

type Variables = {
  limit: number;
  page: number;
  isInterested?: boolean;
  isSaved?: boolean;
  multipleCandidates?: boolean;
  keyword?: string;
  industries?: string;
  locations?: string;
  roles?: string;
  dateFrom?: number;
  dateTo?: number;
  isSuggested?: boolean;
  startMonths?: string;
  categories?: string;
  traits?: string;
};

type SearchJobsResult = { total_count: number; data: Array<JobType> };

type QueryError = {};

const useSearchJobsQuery = (
  variables: Variables,
  queryString: string,
  options?: UseQueryOptions<
    SearchJobsResult,
    QueryError,
    SearchJobsResult,
    QueryKey
  >
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${SUPPLIERS_ENDPOINT}/jobs/search`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, JSON.stringify(variables), tid];

  return useQuery<SearchJobsResult, QueryError>(
    cacheKey,
    async () => {
      const params: any = {
        tid: tid,
        ...Object.fromEntries(
          Object.entries(variables).filter(
            ([key, value]) => Boolean(value) || key === "isSuggested"
          )
        ),
      };

      const res = await fetchWithAuth<SearchJobsResult>(url, {
        params,
        queryString,
      });
      return res;
    },
    {
      enabled: !!tid,
      ...options,
    }
  );
};
export default useSearchJobsQuery;
